import { HostEnv } from "../../../Cpq";

/**
 * Get host env
 * Prop passed to <Cpq /> initially. Ported from old global config
 */
export const getHostEnv = (state: any) => state.order.hostEnv as HostEnv;
